import L from "leaflet";
import { GeoUtils } from "./geo-utils";

export class WaypointUtils {
    static drawSegments(latLngs, segmentOptions = null) {
        if (!latLngs) return;

        const routeLines = [];

        latLngs = latLngs.map(l => GeoUtils.toLatLng(l));
        let sameHemi = [latLngs[0]];

        for (let idx = 1; idx < latLngs.length; idx++) {
            let wp1 = sameHemi.at(-1);
            let wp2 = latLngs[idx];

            const isCrossing = GeoUtils.isCrossingDateLine(wp1, wp2);

            if (isCrossing) {
                const n1 = GeoUtils.normalizedLatLng(wp1);
                const n2 = GeoUtils.normalizedLatLng(wp2);

                if (n1.lng > n2.lng) {
                    if (wp1.lng > wp2.lng)
                        wp2 = L.latLng(wp2.lat, wp2.lng + 360);
                }
                else {
                    if (wp1.lng < wp2.lng)
                        wp2 = L.latLng(wp2.lat, wp2.lng - 360);
                }
                sameHemi.push(wp2);

                let routeLine = L.polyline(sameHemi, {
                    color: 'blue',
                    weight: 2,
                    clickable: false,
                    interactive: false,
                    ...(segmentOptions?.() ?? {})
                });

                routeLines.push(routeLine)

                sameHemi = [latLngs[idx]];
            }
            else {
                sameHemi.push(wp2);
            }
        }

        if (sameHemi.length > 1) {
            let routeLine = L.polyline(sameHemi, {
                color: 'blue',
                weight: 2,
                clickable: false,
                interactive: false,
                ...(segmentOptions?.() ?? {})
            });

            routeLines.push(routeLine)
        }

        return routeLines;
    }

    static drawSegmentsIndividual(latLngs, segmentOptions = null) {
        if (!latLngs) return;

        const routeLines = [];

        for (let idx = 0; idx < latLngs.length - 1; idx++) {
            let wp1 = GeoUtils.toLatLng(latLngs[idx]);
            let wp2 = GeoUtils.toLatLng(latLngs[idx + 1]);
                
            const isCrossing = GeoUtils.isCrossingDateLine(wp1, wp2);

            if (isCrossing) {
                const n1 = GeoUtils.normalizedLatLng(wp1);
                const n2 = GeoUtils.normalizedLatLng(wp2);

                if (n1.lng > n2.lng) {
                    if (wp1.lng > wp2.lng)
                        wp2 = L.latLng(wp2.lat, wp2.lng + 360);
                }
                else {
                    if (wp1.lng < wp2.lng)
                        wp2 = L.latLng(wp2.lat, wp2.lng - 360);
                }
            }

            let routeLine = L.polyline([wp1, wp2], {
                color: 'blue',
                weight: 2,
                clickable: false,
                interactive: false,
                ...(segmentOptions?.() ?? {})
            });

            routeLines.push(routeLine)
        }

        return routeLines;
    }
}